<template>
  <el-dialog
      :close-on-click-modal="false"
      :title="'出车打款费用上传'"
      :lock-scroll="true"
      :visible.sync="dialogFormVisible"
      width="500px"
  >
    <section v-loading="getDetailLoading">
      <qx-custom-form @sub="sub" :noSubBtn="true" ref="customForm" :formData="formData" labelWidth="150px">
      </qx-custom-form>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button
          type="primary"
          @click="customFormPost"
          :loading="subLoading || getDetailLoading"
      >确定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  updateOrderMoneyPoof,
} from 'api/operate';
import {
  getFileUrl,
} from 'api';
export default {
  data () {
    return {
      proof: [],
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      originData: {},
      id: '',
      formData: {
        form: [
          {
            label: '核销内容',
            value: 'moneyTypeName',
            type: 'show',
          },
          {
            label: '预支金额',
            value: 'moneyTypeValueDouble',
            type: 'input',
          },
          {
            label: '实际金额',
            value: 'moneyValuePayDouble',
            type: 'input',
          },
          {
            label: '凭证',
            value: 'file',
            type: 'img',
            accept: 'image/*',
            default: [],
          },
          {
            label: '备注',
            value: 'remarks',
            type: 'input',
          },
        ],
        rules: {
          moneyValuePayDouble: [
            { required: true, message: '请输入实际金额', trigger: 'blur' },
          ],
          file: [
            { required: true, message: '请上传凭证', trigger: 'blur' },
          ],
          remarks: [
            { required: true, message: '请输入备注', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗

      this.$nextTick(() => {
        this.$refs.customForm && this.$refs.customForm.reset();
        this.proof = [];
        this.originData = item;
        this.id = item.id;
        this.proof = this.parseProofList(this.originData.proof);
        this.$refs.customForm.setVal('moneyTypeName', this.originData.moneyTypeName);
        this.$refs.customForm.setVal('moneyTypeValueDouble', this.originData.moneyTypeValueDouble);
        this.$refs.customForm.setVal('moneyValuePayDouble', this.originData.moneyValuePayDouble);
        this.$refs.customForm.setVal('remarks', this.originData.remarks);
        let files = [];
        this.proof.forEach((element) => {
          files.push({
            id: element.id || element.flowId,
            url: this.getServerFileUrl(element),
            storePath: this.getServerStorePath(element),
          });
        });
        this.$refs.customForm.setVal('file', files);
      });
    },
    parseProofList (proof) {
      if (!proof) {
        return [];
      }
      if (Array.isArray(proof)) {
        return proof;
      }
      if (typeof proof !== 'string') {
        return [];
      }
      try {
        return JSON.parse(proof);
      } catch (err) {
        const normalizedProof = proof
          .replace(/&quot;/g, '"')
          .replace(/([?&][A-Za-z0-9_-]+)":"/g, '$1=')
          .replace(/(filename\*=UTF-8''[^",}\]]*)"/g, '$1%22')
          .replace(/(filename=)"([^"\r\n]*)"/g, '$1%22$2%22');
        try {
          return JSON.parse(normalizedProof);
        } catch (parseErr) {
          console.error('[driveModifyDialog] proof JSON parse failed:', parseErr, proof);
          return [];
        }
      }
    },
    customFormPost () {
      this.$refs.customForm.sub();
    },
    normalizeProofUrl (url) {
      return typeof url === 'string' ? url.replace(/&amp;/g, '&') : url;
    },
    isLocalBlobUrl (url) {
      return typeof url === 'string' && url.indexOf('blob:') === 0;
    },
    getUploadFlowId (value) {
      if (!value) {
        return '';
      }
      if (typeof value === 'string' || typeof value === 'number') {
        const text = `${value}`;
        return text === '[object Object]' ? '' : text;
      }
      if (Array.isArray(value)) {
        for (let i = 0; i < value.length; i++) {
          const id = this.getUploadFlowId(value[i]);
          if (id) {
            return id;
          }
        }
        return '';
      }
      const candidates = [
        value.flowId,
        value.id,
        value.attachId,
        value.fileId,
        value.data,
        value.content,
        value.result,
        value.items,
        value.rows,
        value.response,
      ];
      for (let i = 0; i < candidates.length; i++) {
        const id = this.getUploadFlowId(candidates[i]);
        if (id) {
          return id;
        }
      }
      return '';
    },
    getServerFileUrl (item) {
      if (!item) {
        return '';
      }
      const candidates = [item.fullPathUrl, item.fullPath, item.url, item.picFullUrl, item.storePath, item.picUrl];
      for (let i = 0; i < candidates.length; i++) {
        const url = this.normalizeProofUrl(candidates[i]);
        if (url && !this.isLocalBlobUrl(url)) {
          return url;
        }
      }
      return '';
    },
    getServerStorePath (item) {
      if (!item) {
        return '';
      }
      const candidates = [item.storePath, item.picUrl, item.fullPath, item.fullPathUrl, item.picFullUrl, item.url];
      for (let i = 0; i < candidates.length; i++) {
        const url = this.normalizeProofUrl(candidates[i]);
        if (url && !this.isLocalBlobUrl(url)) {
          return url;
        }
      }
      return '';
    },
    getFileInfoFromQueryResult (urlRes) {
      if (!urlRes) {
        return null;
      }
      if (Array.isArray(urlRes)) {
        return urlRes[0] || null;
      }
      const rows = Array.isArray(urlRes.rows) ? urlRes.rows : (Array.isArray(urlRes.items) ? urlRes.items : []);
      if (rows.length) {
        return rows[0];
      }
      const dataRows = urlRes.data && (Array.isArray(urlRes.data.rows) ? urlRes.data.rows : (Array.isArray(urlRes.data.items) ? urlRes.data.items : []));
      if (dataRows && dataRows.length) {
        return dataRows[0];
      }
      if (urlRes.data && (this.getServerFileUrl(urlRes.data) || this.getServerStorePath(urlRes.data))) {
        return urlRes.data;
      }
      if (this.getServerFileUrl(urlRes) || this.getServerStorePath(urlRes)) {
        return urlRes;
      }
      return null;
    },
    async queryFileInfoByFlowId (flowId) {
      if (!flowId) {
        return null;
      }
      try {
        const urlRes = await getFileUrl({
          flowIds: flowId,
          _GRID_TYPE: 'jq',
        });
        return this.getFileInfoFromQueryResult(urlRes);
      } catch (err) {
        console.error('[driveModifyDialog] query uploaded proof url failed:', err, flowId);
        return null;
      }
    },
    async normalizeProofFile (item) {
      const fileId = this.getUploadFlowId(item.id || item.flowId || item.response || item);
      const responseInfo = this.getFileInfoFromQueryResult(item.response);
      let fileInfo = responseInfo ? { ...item, ...responseInfo } : item;
      if (!this.getServerFileUrl(fileInfo) || !this.getServerStorePath(fileInfo)) {
        const queriedInfo = await this.queryFileInfoByFlowId(fileId);
        fileInfo = queriedInfo ? { ...item, ...queriedInfo } : fileInfo;
      }
      return {
        flowId: fileId,
        picFullUrl: this.getServerFileUrl(fileInfo),
        picUrl: this.getServerStorePath(fileInfo),
      };
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      this.subLoading = true;
      let formData = null;

      const fileList = Array.isArray(form && form.file) ? form.file.filter((item) => item && (item.id || item.response || item.flowId || item.storePath || item.picUrl || item.url)) : [];
      if (!fileList.length) {
        this.subLoading = false;
        this.$message({
          type: 'warning',
          message: '请等待凭证上传完成后再提交',
        });
        return;
      }

      let picFileIds = [];
      for (let item of fileList) {
        const proofFile = await this.normalizeProofFile(item);
        if (!proofFile.flowId || !proofFile.picUrl || !proofFile.picFullUrl) {
          this.subLoading = false;
          this.$message({
            type: 'warning',
            message: '凭证图片地址获取失败，请稍后重试',
          });
          return;
        }
        picFileIds.push(proofFile);
      }
      form.proof = picFileIds;
      if (this.originData.id) {
        form.id = this.originData.id;
      }
      delete form.file;
      if (form) {
        formData = {
          orderId: this.originData.orderId,
          ...form,
          proof: JSON.stringify(form.proof),
        };
      }

      const res = await updateOrderMoneyPoof(formData);
      this.subLoading = false;
      if (!res.failed) {
        this.dialogFormVisible = false; // 关闭弹窗
        this.$message({
          type: 'success',
          message: '上传成功',
        });
        this.$emit('sub');
      }
    },
  },
};
</script>

<style>
</style>
